import React, { useState } from "react";
import { HiEye, HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";

const SpendsCard = ({ spends, index, handleSpendUpdate, spendDeletingReq }) => {
  const [show, setShow] = useState(false);

  const handleClick = () => {
    show ? setShow(false) : setShow(true);
  };

  return (
    <div className="col-lg-4 col-md-6" key={index}>
      <div
        className={`card-container ${show ? "hover-block-card" : ""}`}
        onClick={handleClick}
      >
        <span>{spends?.name}</span>
        <div className="icon-edit">
          <button
            style={{ all: "unset" }}
            onClick={(e) => handleSpendUpdate(e, spends)}
          >
            <HiPencilAlt size={20} />
          </button>
        </div>
        <div className="icon-view">
          <Link
            to={`/spends/view`}
            state={{id : spends?.id}}
            style={{ textDecoration: "inherit", color: "inherit" }}
          >
            {" "}
            <HiEye size={20} />
          </Link>
        </div>
        <div className="icon-delete">
          <button
            style={{ all: "unset" }}
            onClick={(e) => {
              spendDeletingReq(e, spends?.id);
            }}
          >
            <FaTrash size={15} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpendsCard;
